module.exports = __webpack_public_path__ + "img/img_nav_person-w.f888bbdf.svg";